import { MULTITABSINTURNO_SETPASO } from "../../ActionTypes";

export const setPasoMultitabSinTurno = (paso) => (dispatch) => {
  dispatch({
    type: MULTITABSINTURNO_SETPASO,
    payload: paso
  });
};
